// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"101":"component---src-templates-home-js","223":"commons","342":"ea88be26","972":"component---src-templates-error-page-js"}[chunkId] || chunkId) + "-" + {"101":"22eeae6f8034a220d992","223":"151e63dd1cd0cbf7a775","342":"526a7325677ea3615087","522":"87d22c0afaf73d003d09","972":"cee3b2d567d56913c228"}[chunkId] + ".js";
};